<template>
	<v-col class="block_cont" :class="{ 'is-loop': isLoop }">
		<FlowTreeActionBlock v-on="$listeners" v-bind="props" class="action-block-wrapper" />
	</v-col>
</template>

<script>
import BlockPropsComputedsMixin from './BlockPropsComputedsMixin';
import FlowTreeActionBlock from './FlowTreeActionBlock.vue';

export default {
	name: 'FlowTreeBlockContainer',
	mixins: [BlockPropsComputedsMixin],
	props: {
		isChosen: { type: Boolean },
	},
	components: { FlowTreeActionBlock },
	computed: {
		props() {
			return { ...this.$attrs, ...this.$props };
		},
	},
};
</script>

<style lang="scss" scoped>
.block_cont {
	max-width: 300px;
	&.is-loop {
		display: flex;
		align-items: center;
		justify-content: center;

		::v-deep {
			.menu_btn {
				position: absolute;
				top: -6px;
				left: -2px;
				transform: rotate(45deg) scale(0.75);
			}
		}
	}
	::v-deep(.action-block) {
		width: 290px;
	}
}
</style>
